import * as React from "react";
import { Avatar, Button, Flex, Image, Label, Segment, Text, Tooltip } from "@fluentui/react-northstar";
import { initializeIcons, Icon } from '@fluentui/react';
import { withTranslation, WithTranslation } from "react-i18next";
import StatusQueueConstants from "../../../constants/status-queue";

interface IQueueCancelledProps extends WithTranslation {
    botWriting1: boolean;
    ancora: string;
    appConfigs: any;
    appSettings: any;
    meetingQueueData: any;
}

const QueueCancelledCard: React.FunctionComponent<IQueueCancelledProps> = props => {
    const localize = props.t;
    initializeIcons();

    const scheduled = props.meetingQueueData.history?.some((history: any) => history?.status == StatusQueueConstants.atendimentoAgendado);

    return (
        <React.Fragment>
            <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                <Avatar icon={<Image src="/images/logo.png" />} />
                <Flex.Item grow>
                    <Segment
                        hidden={props.botWriting1}
                        className="dialog2"
                        color="brand"
                        content={
                            <Flex gap="gap.large" column>
                                <Text weight="bold" size="large" content={`${localize("AtendimentoCancelado")}!`} />

                                <Flex>
                                    <Flex column>
                                        <Label
                                            className="endLabel"
                                            content={(
                                                <Flex gap="gap.medium" padding="padding.medium" hAlign="center" column>
                                                    <Text align="center" styles={{ marginTop: "32px" }} weight="light" content={localize("AtendimentoCanceladoFila")} />
                                                    <Tooltip
                                                        align="center"
                                                        position="below"
                                                        trigger={<Icon className="info-icon" iconName="Info" />}
                                                        content={`Protocolo #${props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}`}
                                                    />
                                                    <Button
                                                        hidden={scheduled}
                                                        content={localize("EntrarNovamente")}
                                                        onClick={() => {
                                                            window.location.href = `/meeting/${props.ancora}`;
                                                        }}
                                                        primary
                                                    />
                                                </Flex>
                                            )}
                                        />
                                    </Flex>
                                    {props.appConfigs && props.appConfigs.imgEnd != "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src={props.appConfigs.imgEnd} />
                                        </Flex.Item>
                                    }

                                    {props.appConfigs && props.appConfigs.imgEnd == "" &&
                                        <Flex.Item align="center" className="fila">
                                            <Image src="/images/cancel.svg" className="canceled" />
                                        </Flex.Item>
                                    }
                                </Flex>
                            </Flex>
                        }
                    />
                </Flex.Item>
            </Flex>
        </React.Fragment>
    );
};

const queueCancelledWithTranslation = withTranslation()(QueueCancelledCard);
export default queueCancelledWithTranslation;